import { useContext, useMemo } from 'react';
import { LicenseContext } from '../contexts/LicenseContext';
import { LicensesContext } from '../contexts/LicensesContext';

export const usePackagesInSameLicenseFile = () => {
  const license = useContext(LicenseContext)!;
  const { licenses } = useContext(LicensesContext);

  return useMemo(() => {
    if (!license || !licenses) {
      return {
        groupedIds: {
          basePackages: [],
          addonPackages: [],
        },
        all: [],
      };
    }
    return {
      groupedIds: {
        basePackages: licenses
          .filter(
            (licenseIter) => !licenseIter.isAddon && licenseIter.offlineLicensePath === license.offlineLicensePath
          )
          .map(({ id }) => id!),
        addonPackages: licenses
          .filter((licenseIter) => licenseIter.isAddon && licenseIter.offlineLicensePath === license.offlineLicensePath)
          .map(({ id }) => id!),
      },
      all: licenses.filter((licenseIter) => licenseIter.offlineLicensePath === license.offlineLicensePath),
    };
  }, [licenses, license]);
};
